import { arrayWrap } from '../core/helpers';

export default {
  props: {
    param: {
      type: String,
      required: true,
    },
    trackBy: {
      type: String,
      default: 'value',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'label',
    },
    options: {
      type: Array,
      default: () => [
        { label: 'Croissant', value: 'asc' },
        { label: 'Décroissant', value: 'desc' },
      ],
    },
  },

  data() {
    return {
      selected: this.multiple ? [] : null,
    };
  },

  mounted() {
    this.setSelected();
    Event.listen('onpopstate', () => this.setSelected());
  },

  methods: {
    getParam() {
      const params = new URLSearchParams(window.location.search);
      return params.has(this.param) ? params.get(this.param) : null;
    },

    setSelected() {
      this.selected = this.multiple ? [] : null;
      const params = this.getParam();

      if (!params) {
        return;
      }

      const options = this.options.filter(option => params.includes(option[this.trackBy]));
      this.selected = this.multiple ? options : (options[0] || null);
    },

    updateUrlParam(value) {
      const params = new URLSearchParams(window.location.search);
      params.set(this.param, value);
      params.delete('page');
      history.pushState(null, '', `?${params.toString()}`);
      return this;
    },

    removeUrlParam() {
      const params = new URLSearchParams(window.location.search);
      params.delete(this.param);
      params.delete('page');
      history.pushState(null, '', `?${params.toString()}`);
      return this;
    },

    broadcast() {
      return this.$emit('applied');
    },

    handleInput(selected) {
      this.selected = selected;

      if (!selected || (Array.isArray(selected) && !selected.length)) {
        this.removeUrlParam().broadcast();
        return;
      }
      const params = arrayWrap(selected).map(option => option[this.trackBy]).join(',');
      this.updateUrlParam(params).broadcast();
    },
  },
};
